var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tab',{attrs:{"title":_vm.customTab.title}},[_c('b-card-body',{attrs:{"tabindex":"0","aria-label":_vm.customTab.title}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.customTab.render_template)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }